/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */


import interfaceService from './interfaceService';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';
import { buynowAdd, buynowDetail, cancelBuynowOrder, cancelInvoiceOrder, invoiceDetail, invoiceOrderDetail, orderAdd, receiptCheck, bidderAccept } from 'shared/settings/apiconfig';


class InvoiceService {
    constructor() {
        this.service = interfaceService.getService();
    }

    getInvoiceDetail(invoiceId) {
        return this.service.get(getBuyersUrl(`${invoiceDetail}/${invoiceId}`), getBuyerHeaders());
    }

    getInvoiceOrderDetail(invoiceId) {
        return this.service.get(getBuyersUrl(`${invoiceOrderDetail}/${invoiceId}`), getBuyerHeaders());
    }

    createInvoiceOrderDetail(data) {
        return this.service.post(getBuyersUrl(`${orderAdd}`), JSON.stringify(data), getBuyerHeaders());
    }

    cancelInvoiceOrder(invoiceId) {
        return this.service.get(getBuyersUrl(`${cancelInvoiceOrder}/${invoiceId}`), getBuyerHeaders());
    }

    getBuynowDetail(itemId) {
        return this.service.get(getBuyersUrl(`${buynowDetail}/${itemId}`), getBuyerHeaders());
    }

    createBuynowOrderDetail(data) {
        return this.service.post(getBuyersUrl(`${buynowAdd}`), JSON.stringify(data), getBuyerHeaders());
    }

    cancelBuynowOrder(itemId) {
        return this.service.get(getBuyersUrl(`${cancelBuynowOrder}/${itemId}`), getBuyerHeaders());
    }

    receiptCheck(invoiceId) {
        return this.service.get(getBuyersUrl(`${receiptCheck}/${invoiceId}`), getBuyerHeaders());
    }

    receiptUpdate(invoiceId, data) {
        return this.service.post(getBuyersUrl(`${receiptCheck}/${invoiceId}`), JSON.stringify(data), getBuyerHeaders());
    }

    bidderAccept(invoiceId, data) {
        return this.service.put(getBuyersUrl(`${bidderAccept}/${invoiceId}`), JSON.stringify(data), getBuyerHeaders());
    }
}

export default new InvoiceService();